<div *ngIf="loading">
  <div class="loader-span"></div>
</div>

<div class="contents">
    <div class="modal-header">
      <h3 class="modal-title">
         <span>{{title}} Yacht Marketing Configuration</span>
      </h3>
    </div>
    <div class="modal-body">
      
      <form [formGroup]="marketingConfigurationForm" (ngSubmit)="addConfigurationSubmit(marketingConfigurationForm.value)" id="addMarketingForm">
            <div class="row">
              <div class="col-6 pr-4">
                <div class="clearfix"></div>
                <input id="thumbnail" style="display: none;"  (change)="picked($event, configurationData?.marketingId || configurationData?._id || configurationData?.id ? 'update' : 'create')" type="file" name="image"
                  class="browse-file" />
                <label for="thumbnail" class="upload pl-0">
                  <div for="thumbnail" class="droparea">
                    <div class="img-upload">
                      <div class="img-up" *ngIf="!uploadfile && !imagePathURL">
                        <span><img src="./../assets/images/profile-car.svg" alt="uploadIcon"></span>
                      </div>
                      <div class="img-up" *ngIf="uploadfile || imagePathURL">
                        <div><img [src]="imagePathURL" alt="Moniic"></div>
                      </div>
                    </div>
                    <div class="text-upload">
                      <h6>Upload Image <span class="text-danger">*</span></h6>
                      <p>.jpeg or png. Max 500 KB</p>
                    </div>
                  </div>
                </label>
                <h6 id="file_detail" class="error"></h6>
                <div *ngIf="marketingConfigurationForm.errors?.imageRequired && (marketingConfigurationForm.touched || marketingConfigurationForm.dirty)">
                  <span class="error sum">Upload Image is required.</span>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 pb-3 left-p">
                <label for="ex1">Image Title </label>
              </div>
              <div class="col-6 left-p pb-3">
                <div *ngFor="let lang of languages" class="pb-3">
                  <div
                    [class.err-input]="
                      marketingConfigurationForm.controls['imageTitle_' + lang.key]?.invalid &&
                      (marketingConfigurationForm.controls['imageTitle_' + lang.key]?.dirty || marketingConfigurationForm.controls['imageTitle_' + lang.key]?.touched)
                    "
                  >
                    <input
                      class="form-control"
                      type="text"
                      [id]="'imageTitle_' + lang.key"
                      [name]="'imageTitle_' + lang.key"
                      [formControlName]="'imageTitle_' + lang.key"
                      placeholder="Enter Image Title in {{ lang.label }}"
                      [minLength]="1"
                      [maxLength]="30"
                    />
                    <div
                      *ngIf="
                        marketingConfigurationForm.controls['imageTitle_' + lang.key]?.invalid &&
                        (marketingConfigurationForm.controls['imageTitle_' + lang.key]?.dirty || marketingConfigurationForm.controls['imageTitle_' + lang.key]?.touched)
                      "
                    >
                      <div *ngIf="marketingConfigurationForm.controls['imageTitle_' + lang.key]?.errors?.minlength">
                        <span class="error sum">Image Title must be at least 1 character.</span>
                      </div>
                      <div *ngIf="marketingConfigurationForm.controls['imageTitle_' + lang.key]?.errors?.maxlength">
                        <span class="error sum">Image Title must not exceed 30 characters.</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="marketingConfigurationForm.errors?.imageTitle_Required && marketingConfigurationForm.touched">
                  <span class="error sum">At least one language must be filled for Image Title.</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 pb-3 left-p">
                <label for="ex1">Description </label>
              </div>
              <div class="col-6 left-p pb-3">
                <div *ngFor="let lang of languages" class="pb-3">
                  <div
                    [class.err-input]="
                      marketingConfigurationForm.controls['description_' + lang.key]?.invalid &&
                      (marketingConfigurationForm.controls['description_' + lang.key]?.dirty || marketingConfigurationForm.controls['description_' + lang.key]?.touched)
                    "
                  >
                    <textarea
                      class="form-control"
                      type="text"
                      [id]="'description_' + lang.key"
                      [name]="'description_' + lang.key"
                      [formControlName]="'description_' + lang.key"
                      placeholder="Enter Description in {{ lang.label }}"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
                <div *ngIf="marketingConfigurationForm.errors?.description_Required && marketingConfigurationForm.touched">
                  <span class="error sum">At least one language must be filled for Description.</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 pb-3 left-p">
                <label for="ex1">CTA </label>
              </div>
              <div class="col-6 left-p pb-3">
                <div
                  [class.err-input]="
                    marketingConfigurationForm.controls['cta'].invalid &&
                    (marketingConfigurationForm.controls['cta'].dirty || marketingConfigurationForm.controls['cta'].touched)
                  "
                >
                  <select class="form-control" name="cta" formControlName="cta">
                    <option value="OPEN_YACHT">Open Yacht</option>
                  </select>
                  <div *ngIf="marketingConfigurationForm.controls['cta'].invalid && (marketingConfigurationForm.controls['cta'].dirty || marketingConfigurationForm.controls['cta'].touched)">
                    <div *ngIf="marketingConfigurationForm.controls['cta'].errors.required">
                      <span class="error sum">CTA Required.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 pb-3 left-p">
                <label for="order">Order <span class="text-danger">*</span></label>
              </div>
              <div class="col-6 left-p pb-3">
                <div
                  [class.err-input]="
                    marketingConfigurationForm.controls['order'].invalid &&
                    (marketingConfigurationForm.controls['order'].dirty || marketingConfigurationForm.controls['order'].touched)
                  "
                >
                  <input
                    class="form-control"
                    type="text"
                    inputmode="numeric"
                    name="order"
                    id="order"
                    formControlName="order"
                    placeholder="Enter Order"
                    NumericInput
                    [maxDigits]="2"
                  />
                  <div *ngIf="marketingConfigurationForm.controls['order'].invalid && (marketingConfigurationForm.controls['order'].dirty || marketingConfigurationForm.controls['order'].touched)">
                    <div *ngIf="marketingConfigurationForm.controls['order'].errors.required">
                      <span class="error sum">Order Required.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 pb-3 left-p">
                <label for="status">Status</label>
              </div>
              <div class="col-6 left-p pb-3">
                <select class="form-control" name="status" formControlName="status">
                  <option value="ACTIVE">Active</option>
                  <option value="INACTIVE">Inactive</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-6 pb-3 left-p">
                <label for="ex1">CTA Text <span class="text-danger">*</span></label>
              </div>
              <div class="col-6 left-p pb-3">
                <div *ngFor="let lang of languages" class="pb-3">
                  <div
                    [class.err-input]="
                      marketingConfigurationForm.controls['ctaText_' + lang.key]?.invalid &&
                      (marketingConfigurationForm.controls['ctaText_' + lang.key]?.dirty || marketingConfigurationForm.controls['ctaText_' + lang.key]?.touched)
                    "
                  >
                    <input
                      class="form-control"
                      type="text"
                      [id]="'ctaText_' + lang.key"
                      [name]="'ctaText_' + lang.key"
                      [formControlName]="'ctaText_' + lang.key"
                      placeholder="Enter CTA Text in {{ lang.label }}"
                      [maxLength]="30"
                    />
                    <div
                      *ngIf="
                        marketingConfigurationForm.controls['ctaText_' + lang.key]?.invalid &&
                        (marketingConfigurationForm.controls['ctaText_' + lang.key]?.dirty || marketingConfigurationForm.controls['ctaText_' + lang.key]?.touched)
                      "
                    >
                      <div *ngIf="marketingConfigurationForm.controls['ctaText_' + lang.key]?.errors?.maxlength">
                        <span class="error sum">CTA Text must not exceed 30 characters.</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="marketingConfigurationForm.errors?.ctaText_Required && marketingConfigurationForm.touched">
                  <span class="error sum">At least one language must be filled for CTA Text.</span>
                </div>
              </div>
            </div>
        
      </form> 
    </div>
    <footer class="modal-footer">
          <button type="button" class="btn btn-cancel"
            (click)="discardChanges()">{{'button.cancel'
            | translate}}</button>
          <button type="submit" class="btn btn-save" [disabled]="marketingConfigurationForm.invalid"  form="addMarketingForm">SAVE</button>
        </footer>
  </div>
  
  
  
  
  <ng-template #successYachtMarketingPopup>
    <div class="modal-body">
      <div class="complete-success">
        <div class="img-con fullImage">
          <img src="{{checkCircle}}" alt="Check Icon" />
        </div>
        <div class="middle-sec">
          <div class="heading">
            {{'carsmanagement.success' | translate}}
          </div>
          <div class="details">
            Yacht Marketing Configuration {{title === 'Add' ? 'added' : 'updated'}} successfully
          </div>
        </div>
        <div>
          <button (click)="modalRef.hide()" class="view fullImage ok">
            {{'button.ok' | translate}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  

